import { GamepadIcon, MessageCircle, UserCircle, Tv, Coins } from "lucide-react";
import { Link, useLocation } from "wouter";
import appSound from '@/services/app-sound-service';
import { useEffect } from "react";
import { audioCache } from "@/services/audio-cache";

export function BottomNav() {
  const [location] = useLocation();
  
  // Ensure audio is initialized
  useEffect(() => {
    // Ensure audio cache is marked as ready for interaction
    document.documentElement.setAttribute('data-user-interacted', 'true');
    audioCache.markUserInteraction();
  }, []);
  
  // Hide bottom nav on specific pages: game rooms, landing, auth, privacy, terms, conversation
  if (location.startsWith('/game/') || 
      location === '/' || 
      location === '/auth' || 
      location === '/privacy-policy' || 
      location === '/terms-of-service' ||
      location.startsWith('/messages/conversation/')) {
    return null;
  }

  const navItems = [
    { icon: Coins, label: "Shop", path: "/shop" },
    { icon: Tv, label: "Watch", path: "/watch" },
    { icon: GamepadIcon, label: "Games", path: "/games" },
    { icon: MessageCircle, label: "Friends", path: "/messages" },
    { icon: UserCircle, label: "Profile", path: "/profile" },
  ];

  // Handle nav item click with sound
  const handleNavClick = () => {
    // Force user interaction state
    audioCache.markUserInteraction();
    // Play the navigation sound
    appSound.playNavSound();
    // Also trigger a button sound as backup
    audioCache.play('ui.button');
    console.log("Navigation sound triggered");
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-t border-primary/20 pb-safe">
      <div className="flex justify-around">
        {navItems.map(({ icon: Icon, label, path }) => (
          <Link key={path} href={path}>
            <div 
              onClick={handleNavClick}
              className={`p-3 flex flex-col items-center cursor-pointer transition-colors ${
                location === path ? "theme-text-primary" : "text-gray-400"
              }`}
            >
              <Icon className="h-6 w-6" />
              <span className="text-xs mt-1 font-medium">{label}</span>
            </div>
          </Link>
        ))}
      </div>
    </nav>
  );
}